import Toast from '../components/common/pop-up-message';
import useAuth from '../hooks/utils/useAuth';
import { useNotifications } from '../hooks/api/useNotifications';
import { getMemberPrivacyKey, getMemberTermsKey, useVersionedRecordAcceptance } from '../hooks/api/useVersionedRecords';
import { resolveTheme } from '../themes';
import { AdminRouter } from './admin-router';
import { OnboardingRouter } from './onboarding-router';
import { PeerRouter } from './peer-router';
import { TermsAndConditionsRouter } from './terms-and-conditions-router';
import { useEffect } from 'react';
import { MwaRouter, NonActiveMwaRouter } from './caller-router';
import { UnauthenticatedRouter } from './unauthenticated-router';

export const AuthenticatedRouter = () => {
  const { user, logout, setRedirectTo } = useAuth();
  const theme = resolveTheme();
  const memberTermsKey = getMemberTermsKey(theme.id);
  const memberPrivacyKey = getMemberPrivacyKey(theme.id);
  const { data: termsOfServiceAccepted } = useVersionedRecordAcceptance(memberTermsKey);
  const { data: privacyPolicyAccepted } = useVersionedRecordAcceptance(memberPrivacyKey);
  useNotifications();

  const trustedSSO = user?.caller_role?.active_subscription?.package?.client?.trusted_sso;
  // const trustedSSO = true;
  const skipTermsAndPrivacy = termsOfServiceAccepted?.accepted && privacyPolicyAccepted?.accepted;

  useEffect(() => {
    setRedirectTo(null);
  }, []);

  const renderRouter = () => {
    // she doesn't even go here
    if (!user?.caller_role_id) {
      if (user?.listener_role_id) return <PeerRouter />;
      if (user?.administrator_role_id || user?.client_administrator_role_id) return <AdminRouter />;

      // something horrible has happened here
      return <UnauthenticatedRouter />;
    }

    // Partial signup must run before active_subscription check — new members may not have a
    // subscription row until after package_code signup + backend provisioning.
    if (user?.is_partial && !trustedSSO) {
      return <OnboardingRouter />;
    }

    if (!user?.caller_role?.active_subscription) {
      Toast.error(`Your member plan has expired. Please contact your organization's administrator to renew your plan.`);
      logout();
      return <NonActiveMwaRouter />;
    }

    // trusted sso user who needs to accept terms and conditions
    if (trustedSSO && !skipTermsAndPrivacy) {
      return <TermsAndConditionsRouter />;
    }

    // you're an active user!
    return <MwaRouter />;
  };

  return renderRouter();
};
